import { render, staticRenderFns } from "./ArticlesBottom.vue?vue&type=template&id=4d474966&scoped=true&"
import script from "./ArticlesBottom.vue?vue&type=script&lang=js&"
export * from "./ArticlesBottom.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesBottom.vue?vue&type=style&index=0&id=4d474966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d474966",
  null
  
)

export default component.exports